module.exports = __webpack_public_path__ + "static/fonts/arial.6dd6913.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/arial.otf
// module id = mJhL
// module chunks = 1